import * as angular from "angular";
import {TestprepRootScope} from "../models/testprep-rootscope.model";
import {LayoutInitService} from "../layout-init/layout-init.service";

export function initRun(app: angular.IModule) {
    /* @ngInject */
    app.run(function ($rootScope: TestprepRootScope, $analytics: angulartics.IAnalyticsService,
                      $location: angular.ILocationService, layoutInitService: LayoutInitService, BASE_URL: string) {

        $rootScope.clearLoadingError = () => {
            $rootScope.loadingError = false;
        };

        $rootScope.$on("$routeChangeStart", function (event: angular.IAngularEvent, next: angular.route.IRoute,
                                                      current: angular.route.IRoute) {
            $rootScope.loadingError = false;
            //refresh scenario
            if (!current) {
                layoutInitService();
            }

            if (next.redirectTo === "/") {
                event.preventDefault();
            }
            if (next.resolve) {
                // Show a loading message until promises aren't resolved
                $rootScope.loadingView = true;
            }
        });

        $rootScope.$on("$routeChangeSuccess", function () {
            // Hide loading message
            $rootScope.loadingView = false;
            $analytics.pageTrack(`${BASE_URL}${$location.path()}`);
        });

        $rootScope.$on("$routeChangeError", function () {
            // Hide loading message
            $rootScope.loadingView = false;
            $rootScope.loadingError = true;
        });
    });
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/app-run/app.run.ts
 **/